import ApiConnector from "../apiConnector";

class ReportDataFetcher {
  private readonly apiConnector: ApiConnector;

  constructor(baseURL: string) {
    this.apiConnector = new ApiConnector(baseURL);
  }

  public async getR06(year: number): Promise<any> {
    return await this.apiConnector.getBlob<any>("report/R06/" + year);
  }

  public async getMonthly(year: number, month: number, weekly: boolean, daily: boolean) {
    return await this.apiConnector.getBlob<any>(`report/Monthly/${year}/${month}/${weekly}/${daily}`);
  }
  public async getSap(year: number, month: number, weekly: boolean) {
    return await this.apiConnector.getBlob<any>(`report/SAP/${year}/${month}/${weekly}`);
  }

  public async getDataForInvoice(serviceId: number, year: number, month: number): Promise<any> {
    return await this.apiConnector.get<any>(`report/invoice/${serviceId}/${year}/${month}`);
  }

  public async getMonhtlyUser(year: number, month: number, userId: string): Promise<any> {
    return await this.apiConnector.getBlob<any>(`report/monthlyUser/${year}/${month}/${userId}`);
  }

  public async getSiteWork(fromYear: number, fromMonth: number, toYear: number, toMonth: number) {
    return await this.apiConnector.getBlob<any>(`report/siteWork/${fromYear}/${fromMonth}/${toYear}/${toMonth}`);
  }
}

export default ReportDataFetcher;
